"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportSelectPlugin = void 0;
const BasePlugin_1 = require("./BasePlugin");
class ExportSelectPlugin extends BasePlugin_1.BasePlugin {
  execute(list, _activities, _groups, _conditions, _selected) {
    const groupActivityMap = new Map();
    for (const activity of list) {
      const groupId = activity.activity_group_id;
      if (!groupId) continue;
      groupActivityMap.set(groupId, (groupActivityMap.get(groupId) || []).concat([activity.id]));
    }
    for (const activity of list) {
      // if disabledbyid is not present, then we cannot enable it as well.
      if (!activity.disabled || !activity.disabledbyid) continue;
      // if no group, then we cant do anything and it still remains disabled.
      const groupId = activity.activity_group_id;
      if (!groupId) continue;
      const disabledById = activity.disabledbyid;
      const activitiesInGroup = groupActivityMap.get(groupId) || [];
      // if the activity is part of the group which disabled it, then mark it as active.
      if (activitiesInGroup.includes(disabledById)) {
        activity.disabled = false;
      }
    }
    return list;
  }
}
exports.ExportSelectPlugin = ExportSelectPlugin;
